const rangerPassiveImageLink = 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png';

export default {
    name: 'Ranger',
    endurancePerLevel: 12,
    healthMultiplier: 5,
    accuracy: 30,
    deflection: 20,
    skillBonuses: {
        stealth: +1,
        survival: +2
    },
    baseAbility: {
        name: 'Animal Companion',
        link: 'https://pillarsofeternity.fandom.com/wiki/Animal_Companion',
        imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
        level: '1',
        activation: 'Passive',
        effects: '<ul><li>Depends on type of Animal Companion</li></ul>',
        speed: 'Average',
        duration: '',
        description: 'All rangers form a strong spiritual connection with a single creature, their animal companion. This connection allows rangers and their companions to coordinate attacks and efficiently take down prey. In most situations, the companion runs interference while the ranger attacks at range.',
    },
    abilities: [
        {
            name: 'Marked Prey',
            link: 'https://pillarsofeternity.fandom.com/wiki/Marked_Prey',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e3/Marked_prey_icon.png',
            level: '1',
            activation: 'Active',
            effects: '<ul><li>Foe Target: Marked</li><li>Self: +20% <a href="/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a> against Marked targets</li></ul>',
            speed: 'Average',
            duration: '30.0 seconds',
            description: 'Designates a single target as prey, giving the ranger and animal companion a damage bonus against that target.',
        },
        {
            name: 'Wounding Shot',
            link: 'https://pillarsofeternity.fandom.com/wiki/Wounding_Shot',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/c/c3/Wounding_shot_icon.png',
            level: '1',
            activation: 'Active',
            effects: '<ul><li>Target: If successful: <a href="/wiki/Hobbled" class="mw-redirect" title="Hobbled">Hobbled</a> (<a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="/wiki/Fortitude" title="Fortitude"><img alt="Fortitude" src="https://static.wikia.nocookie.net/eternitywiki/images/b/b9/Fortitude_icon.png" decoding="async" width="18" height="18" /></a>)</li><li>User: <a href="/wiki/Primary_Attack?action=edit&amp;redlink=1" class="new" title="Primary Attack (page does not exist)">Primary Attack</a>, +100% damage over time (6 seconds) (<a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a>)</li></ul>',
            speed: 'Average',
            duration: '10.0 seconds',
            description: 'As he or she would with fleeing prey, the hunter aims for a spot that will slow the target enemy\'s progress, Hobbling the target and inflicting Raw Damage over time to it.',
        },
        {
            name: 'Predator\'s Sense',
            link: 'https://pillarsofeternity.fandom.com/wiki/Predator%27s_Sense',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '3',
            activation: 'Passive',
            effects: '<ul><li>+50% <a href="/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a> against targets affected by <a href="/wiki/Damage_Over_Time?action=edit&amp;redlink=1" class="new" title="Damage Over Time (page does not exist)">Damage Over Time</a></li></ul>',
            speed: '',
            duration: '',
            description: 'Heightens the predatory instincts of the ranger\'s animal companion, giving them a damage bonus on any creature suffering a damage over time effect.',
        },
        {
            name: 'Swift Aim',
            link: 'https://pillarsofeternity.fandom.com/wiki/Swift_Aim',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/4/4e/Swift_aim_icon.png',
            level: '3',
            activation: 'Modal',
            effects: '<ul><li>+20% <a href="/wiki/Attack_Speed" title="Attack Speed">Attack Speed</a></li><li>+50% <a href="/wiki/Reload_Speed?action=edit&amp;redlink=1" class="new" title="Reload Speed (page does not exist)">Reload Speed</a> (50% faster)</li><li>-7 <a href="/wiki/Accuracy" title="Accuracy">Accuracy</a></li></ul>',
            speed: 'Instant',
            duration: '',
            description: 'The ranger gets into a speedy and fluid offensive rhythm, reducing Accuracy but increasing Fire Rate and reload time with ranged weapon and Attack Rate with melee weapons.',
        },
        {
            name: 'Vicious Aim',
            link: 'https://pillarsofeternity.fandom.com/wiki/Vicious_Aim',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/a/ac/Vicious_aim_icon.png',
            level: '3',
            activation: 'Modal',
            effects: '<ul><li>-20% Ranged <a href="/wiki/Attack_Speed" title="Attack Speed">Attack Speed</a></li><li>-20% <a href="/wiki/Reload_Speed?action=edit&amp;redlink=1" class="new" title="Reload Speed (page does not exist)">Reload Speed</a></li><li>+10 Ranged <a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a></li><li>+20% Ranged <a href="/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a></li></ul>',
            speed: 'Instant',
            duration: '',
            description: 'By lowering Attack and Reload Rate, the ranger is able to take more careful aim, giving them increased Accuracy and Damage.',
        },
        {
            name: 'Arrow Sense',
            link: 'https://pillarsofeternity.fandom.com/wiki/Arrow_Sense',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '5',
            activation: 'Passive',
            effects: '<ul><li>+15 <a href="/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a> against ranged attacks</li></ul>',
            speed: '',
            duration: '',
            description: 'The ranger gains a portion of his or her animal companion\'s senses and instincts, becoming especially sensitive to incoming ranged attacks that target Deflection.',
        },
        {
            name: 'Defensive Bond',
            link: 'https://pillarsofeternity.fandom.com/wiki/Defensive_Bond',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '5',
            activation: 'Passive',
            effects: '<ul><li>Self: +15 <a href="/wiki/Defense" title="Defense">Defense</a> against AoE attacks</li><li>Animal Companion: +15 <a href="/wiki/Defense" title="Defense">Defense</a> against AoE attacks</li></ul>',
            speed: '',
            duration: '',
            description: 'The empathic bond between ranger and animal companion yields a preternatural awareness of incoming danger, giving both a significant bonus to Defense when both are subjected to the same area of effect attack.',
        },
        {
            name: 'Stalkers\' Link',
            link: 'https://pillarsofeternity.fandom.com/wiki/Stalkers%27_Link',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '5',
            activation: 'Passive',
            effects: '<ul><li>+10 <a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> when attacking the same target as animal companion</li></ul>',
            speed: '',
            duration: '',
            description: 'Long experience fighting together enables the ranger and animal companion to fight as a highly efficient team. The ranger gains an accuracy bonus when fighting any enemy already engaged by the animal companion.',
        },
        {
            name: 'Driving Flight',
            link: 'https://pillarsofeternity.fandom.com/wiki/Driving_Flight',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '7',
            activation: 'Passive',
            effects: '<ul><li>Ranged attacks bounce +1 times</li></ul>',
            speed: '',
            duration: '',
            description: 'Each ranged attack loosed by the ranger contains such force as to fly straight through the first target and hit another target behind it for less damage.',
        },
        {
            name: 'Heal Companion',
            link: 'https://pillarsofeternity.fandom.com/wiki/Heal_Companion',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/1/12/Heal_companion_icon.png',
            level: '7',
            activation: 'Active',
            effects: '<ul><li>Animal Companion: +40 <a href="/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a> (base)</li></ul>',
            speed: 'Fast',
            duration: '',
            description: 'The ranger can heal his or her animal companion.',
        },
        {
            name: 'Takedown',
            link: 'https://pillarsofeternity.fandom.com/wiki/Takedown',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/a/af/Takedown_icon.png',
            level: '7',
            activation: 'Active',
            effects: '<ul><li>Foe Target: If successful: <a href="/wiki/Prone" class="mw-redirect" title="Prone">Prone</a> (<a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="/wiki/Fortitude" title="Fortitude"><img alt="Fortitude" src="https://static.wikia.nocookie.net/eternitywiki/images/b/b9/Fortitude_icon.png" decoding="async" width="18" height="18" /></a></li><li>User: <a href="/wiki/Primary_Attack?action=edit&amp;redlink=1" class="new" title="Primary Attack (page does not exist)">Primary Attack</a> (<a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a>)</li></ul>',
            speed: 'Average',
            duration: '5.0 seconds',
            description: 'Instructs the ranger\'s animal companion to rush a target, knocking it Prone.',
        },
        {
            name: 'Binding Roots',
            link: 'https://pillarsofeternity.fandom.com/wiki/Binding_Roots',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/31/Binding_roots_icon.png',
            level: '9',
            activation: 'Active',
            effects: '<ul><li>Foe Target: <a href="/wiki/Stuck" class="mw-redirect" title="Stuck">Stuck</a></li></ul>',
            speed: 'Fast',
            duration: '30.0 seconds',
            description: 'Conjures roots from the ground underneath a target, causing them to become Stuck.',
        },
        {
            name: 'Revive Companion',
            link: 'https://pillarsofeternity.fandom.com/wiki/Revive_Companion',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/0/02/Revive_companion_icon.png',
            level: '9',
            activation: 'Active',
            effects: '<ul><li>Animal Companion: Revive with 50 <a href="/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li></ul>',
            speed: 'Fast',
            duration: '',
            description: 'The ranger can revive his or her animal companion and heal a small amount of Endurance.',
        },
        {
            name: 'Master\'s Call',
            link: 'https://pillarsofeternity.fandom.com/wiki/Master%27s_Call',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/2/29/Masters_call_icon.png',
            level: '11',
            activation: 'Active',
            effects: '<ul><li>Foe Target: 15-20 <a href="/wiki/Slash" title="Slash"><img alt="Slash" src="https://static.wikia.nocookie.net/eternitywiki/images/5/50/Slash_icon.png" decoding="async" width="18" height="18" /></a> damage (<a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs&#160;<a href="/wiki/Deflection" title="Deflection"><img alt="Deflection" src="https://static.wikia.nocookie.net/eternitywiki/images/3/3e/Deflection_icon.png" decoding="async" width="18" height="18" /></a>)</li><li>Foe Target: If successful: <a href="/wiki/Prone" class="mw-redirect" title="Prone">Prone</a> (<a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> vs <a href="/wiki/Fortitude" title="Fortitude"><img alt="Fortitude" src="https://static.wikia.nocookie.net/eternitywiki/images/b/b9/Fortitude_icon.png" decoding="async" width="18" height="18" /></a>)</li></ul>',
            speed: 'Average',
            duration: '5.0 seconds',
            description: 'Calls the ranger\'s animal companion to his or her side, causing the companion to move back to the ranger at increased speed, ignoring Engagement and knocking any enemies in the way Prone.',
        },
        {
            name: 'Play Dead',
            link: 'https://pillarsofeternity.fandom.com/wiki/Play_Dead',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/eb/Play_dead_icon.png',
            level: '11',
            activation: 'Active',
            effects: '<ul><li>+20 <a href="/wiki/Endurance" title="Endurance"><img alt="Endurance" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e8/Endurance_icon.png" decoding="async" width="16" height="16" /></a></li><li>Untargetable</li><li><a href="/wiki/Prone" class="mw-redirect" title="Prone">Prone</a></li><li><a href="/wiki/Damage_Shield?action=edit&amp;redlink=1" class="new" title="Damage Shield (page does not exist)">Damage Shield</a></li></ul>',
            speed: 'Instant',
            duration: '10.0 seconds',
            description: 'The ranger\'s animal companion falls over and appears to be dead (cannot be targeted) for a limited time. While playing dead, the companion regains Endurance.',
        },
        {
            name: 'Stunning Shots',
            link: 'https://pillarsofeternity.fandom.com/wiki/Stunning_Shots',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '11',
            activation: 'Passive',
            effects: '<ul><li>Target: <a href="/wiki/Stunned" class="mw-redirect" title="Stunned">Stunned</a></li></ul>',
            speed: 'Average',
            duration: '2.0 seconds',
            description: 'Takes advantage of enemy distraction while Engaged by the ranger\'s animal companion, Stunning the enemy (as a secondary attack) when the ranger lands a Hit or Critical Hit.',
        },
        {
            name: 'Powder Burns',
            link: 'https://pillarsofeternity.fandom.com/wiki/Powder_Burns',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/e/e6/Powder_burns_icon.png',
            level: '13',
            activation: 'Modal',
            effects: '<ul><li>User: <a href="/wiki/Blinded" class="mw-redirect" title="Blinded">Blinded</a></li><li>Firearm Weapon: Powerful cone of <a href="/wiki/Burn" title="Burn"><img alt="Burn" src="https://static.wikia.nocookie.net/eternitywiki/images/a/aa/Burn_icon.png" decoding="async" width="18" height="18" /></a></li></ul>',
            speed: 'Instant',
            duration: '',
            description: 'The ranger overloads each shot of his or her firearm with excessive powder. The resulting blast generates a powerful cone of flame, but temporarily leaves the ranger Blinded.',
        },
        {
            name: 'Twinned Arrows',
            link: 'https://pillarsofeternity.fandom.com/wiki/Twinned_Arrows',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/8/8b/Twinned_arrows_icon.png',
            level: '13',
            activation: 'Modal',
            effects: '<ul><li>-10 <a href="/wiki/Accuracy" title="Accuracy"><img alt="Accuracy" src="https://static.wikia.nocookie.net/eternitywiki/images/d/df/Accuracy_icon.png" decoding="async" width="16" height="16" /></a> when using <a href="/wiki/War_bow" class="mw-redirect" title="War bow">War bow</a>, <a href="/wiki/Hunting_bow" class="mw-redirect" title="Hunting bow">Hunting bow</a></li><li>+1 Projectiles when using <a href="/wiki/War_bow" class="mw-redirect" title="War bow">War bow</a>, <a href="/wiki/Hunting_bow" class="mw-redirect" title="Hunting bow">Hunting bow</a></li></ul>',
            speed: 'Instant',
            duration: '',
            description: 'When the ranger uses a Hunting Bow or War Bow, they can opt to fire two arrows with each shot.  Each shot has reduced Accuracy.',
        },
        {
            name: 'Vengeful Grief',
            link: 'https://pillarsofeternity.fandom.com/wiki/Vengeful_Grief',
            imageLink: 'https://static.wikia.nocookie.net/eternitywiki/images/3/33/Ranger_passive_icon.png',
            level: '15',
            activation: 'Passive',
            effects: '<ul><li>+20% <a href="/wiki/Damage" title="Damage"><img alt="Damage" src="https://static.wikia.nocookie.net/eternitywiki/images/e/e2/Damage_icon.png" decoding="async" width="18" height="18" /></a></li><li>+1.3 <a href="/wiki/Move_Speed" title="Move Speed">Move Speed</a></li><li>+20% <a href="/wiki/Attack_Speed" title="Attack Speed">Attack Speed</a></li></ul>',
            speed: '',
            duration: '',
            description: 'When a ranger or his or her animal companion are knocked out, the partner suffers the normal effects of Bonded grief, but becomes filled with focused rage for a short duration. While so focused, they gain Speed, Movement, and do additional Damage.',
        },
    ],
    animalCompanions: [
        {
            name: 'Antelope',
        },
        {
            name: 'Bear',
        },
        {
            name: 'Boar',
        },
        {
            name: 'Lion',
        },
        {
            name: 'Stag',
        },
        {
            name: 'Wolf',
        },
        {
            name: 'Itumaak',
            companionOnly: true
        }
    ],
    talents: [
        {
            name: 'Vicious Companion',
            link: 'https://pillarsofeternity.fandom.com/wiki/Vicious_Companion',
            imageLink: rangerPassiveImageLink,
            description: 'Trains the ranger\'s animal companion in vicious tactics, causing it to deal more damage and penetrate Damage Reduction with each hit.'
        },
        {
            name: 'Swift and Steady',
            link: 'https://pillarsofeternity.fandom.com/wiki/Swift_and_Steady',
            imageLink: rangerPassiveImageLink,
            description: 'The ranger becomes better able to shoot quickly, reducing the Accuracy penalty of Swift Aim.',
            requiredAbility: 'Swift Aim'
        },
        {
            name: 'Accurate Wounding Shot',
            link: 'https://pillarsofeternity.fandom.com/wiki/Accurate_Wounding_Shot',
            imageLink: rangerPassiveImageLink,
            description: 'The ranger\'s aim becomes deadlier, making their Wounding Shots more accurate. ',
            requiredAbility: 'Wounding Shot'
        },
        {
            name: 'Brutal Takedown',
            link: 'https://pillarsofeternity.fandom.com/wiki/Brutal_Takedown',
            imageLink: rangerPassiveImageLink,
            description: 'The ranger trains his or her animal companion to inflict Crush damage on opponents when using Takedown.',
            requiredAbility: 'Takedown'
        },
        {
            name: 'Thorny Roots',
            link: 'https://pillarsofeternity.fandom.com/wiki/Thorny_Roots',
            imageLink: rangerPassiveImageLink,
            description: 'The ranger\'s Binding Roots sprout nasty thorns that do additional Pierce and Slash damage to the target.',
            requiredAbility: 'Binding Roots'
        },
        {
            name: 'Faithful Companion',
            link: 'https://pillarsofeternity.fandom.com/wiki/Faithful_Companion',
            imageLink: rangerPassiveImageLink,
            description: 'The ranger\'s animal companion gains improved defenses against Charmed, Confused, and Dominated afflictions.'
        },
        {
            name: 'Resilient Companion',
            link: 'https://pillarsofeternity.fandom.com/wiki/Resilient_Companion',
            imageLink: rangerPassiveImageLink,
            description: 'The ranger\'s animal companion gains improved Damage Reductions against all damage types.'
        },
        {
            name: 'Merciless Companion',
            link: 'https://pillarsofeternity.fandom.com/wiki/Merciless_Companion',
            imageLink: rangerPassiveImageLink,
            description: 'Animal companions do small amounts of Sneak Attack damage against targets that qualify.'
        },
        {
            name: 'Strengthened Bond',
            link: 'https://pillarsofeternity.fandom.com/wiki/Strengthened_Bond',
            imageLink: rangerPassiveImageLink,
            description: 'Increases the shared bonus provided by Defensive Bond.',
            requiredAbility: 'Defensive Bond'
        }
    ]
};
